import {Typography} from "@material-ui/core";
import {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import * as actions from "../../../../../store/e-sim/actions";
import { updateObject } from "shared/utils/updateObject";
import EsitoCambioFormatoFilter from "./esito-cambio-formato-filter/EsitoCambioFormatoFilter";
import { esitoCambioFormatoFilter, sortingCriteria } from "./EsitoCambioFormatoHelper";
import FilterHistory from "shared/components/filter-history/FilterHistory";
import { SortingAndButtonsAboveTable } from "shared/components/sorting-and-buttons-above-table/SortingAndButtonsAboveTable";
import EsitoCambioFormatoTable from "./esito-cambio-formato-table/EsitoCambioFormatoTable";
import ButtonWithProgress from "components/ui/buttons/button-with-progress/ButtonWithProgress";
import GetAppIcon from "@material-ui/icons/GetApp";
import {ESimService} from "api/eSimService";
import {toastError, toastWarning} from "shared/components/toast/Toast";
import fileSaver from 'file-saver';

const EsitoCambioFormato = () => {
    const [filterHistory, setFilterHistory] = useState(esitoCambioFormatoFilter);
    const integrationId = useSelector(state => state.authReducer.selectedCompany.integrationId);
    const totalTableData = useSelector(state => state.eSimReducer.esitoCambioFormatoTableData.total);

    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(5)
    const [areAllSelected, setAreAllSelected] = useState(false)
    const [sorting, setSorting] = useState(`${sortingCriteria[0].value},desc`)
    const [selectedRows, setSelectedRows] = useState([])
    const [csvDownloadLoading, setCsvDownloadLoading] = useState(false)

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(actions.getEsitoCambioFormatoTableData(filterHistory, sorting, page, rowsPerPage))
    }, [dispatch, filterHistory, page, rowsPerPage, sorting, integrationId])

    // useEffect(() => {
    //     dispatch(actions.getEsitoCambioFormatoFilterOptions())
    // }, [dispatch, integrationId])

    const handleFilterSearch = (name, value) => {
        setPage(0);
        setFilterHistory(currentFilterHistory => updateObject(currentFilterHistory, {
            [name]: {
                ...currentFilterHistory[name],
                value: value
            }
        }))
    };

    const handleFilterSelectsSearch = (value) => {
        setPage(0);
        setFilterHistory(currentFilterHistory => updateObject(currentFilterHistory, value))
    };

    const handleRemoveBadge = (key, type, index) => {
        setPage(0);
        setAreAllSelected(false)
        if (type !== "date") {
            setFilterHistory(currentFilterHistory => updateObject(currentFilterHistory, {
                [key]: {
                    ...currentFilterHistory[key],
                    value: type === "primitive" ? "" : [...currentFilterHistory[key].value].filter((i, idx) => idx !== index)
                }
            }))
        } else {
            setFilterHistory(currentFilterHistory => updateObject(currentFilterHistory, {
                [key]: {
                    ...currentFilterHistory[key],
                    from: null,
                    to: null
                }
            }))
        }
    };

    const handleResetFilter = () => {
        setPage(0);
        setAreAllSelected(false)
        setFilterHistory(esitoCambioFormatoFilter);
    };

    const handleSortingChange = (value) => {
        setPage(0)
        setSorting(value)
    };

    const handleAnnullaClick = () => {
        setSelectedRows([])
        setAreAllSelected(false)
    };

    const handleScaricaCsvClick = () => {
        setCsvDownloadLoading(true)
        const sortParts = sorting.split(",")
        ESimService.downloadEsitoCambioFormatoCsv(
            integrationId,
            page,
            rowsPerPage,
            sortParts[0],
            sortParts[1],
            filterHistory.esitoCambioFormato.value,
            filterHistory.numeroDiTelefono.value,
            filterHistory.numeroSeriale.value,
            filterHistory.idLotto.value,
            filterHistory.email.value,
            filterHistory.dataInvioRichiesta.from,
            filterHistory.dataInvioRichiesta.to
        )
            .then((res) => {
                if (res.status === 204) {
                    console.warn("No data was found to be exported in CSV")
                    toastWarning("Non è stato trovato alcun dato da esportare in CSV")
                    return;
                }
                fileSaver.saveAs(res.data, `esito_cambio_formato_${new Date().toISOString()}.csv`)
            })
            .catch((e) => {
                toastError('Errore durante il download del file CSV')
                console.log(e);
            })
            .finally(() => {
                setCsvDownloadLoading(false)
            })
    }

    const scaricaButton = (
        <ButtonWithProgress
            startIcon={<GetAppIcon/>}
            text="scarica .csv"
            handleClick={handleScaricaCsvClick}
            loading={csvDownloadLoading}
            disabled={totalTableData === 0}
            variant="outlined"
        />
    );

    const handleTablePaginationChange = (page, rowsPerPage) => {
        setPage(page);
        setRowsPerPage(rowsPerPage);
    }


    return (
        <>
            <Typography style={{marginBottom: "1.5em"}}
                        variant={"h6"}>
                Esito cambio formato
            </Typography>
            {/* This component si for sorting and filtering */}
            <EsitoCambioFormatoFilter
               handleSearchIcon={handleFilterSearch}
               handleSelectSearch={handleFilterSelectsSearch}
               filter={filterHistory}
            />
            {/* This component is for applying and removing the filter options */}
           <FilterHistory filter={filterHistory}
                           removeFilter={handleRemoveBadge}
                           resetFilter={handleResetFilter}/>

            <SortingAndButtonsAboveTable sortingValue={sorting}
                                         changeSortingCriteria={handleSortingChange}
                                         sortingCriteria={sortingCriteria}
                                         additionalButton={scaricaButton}
                                         hideButton={true}
                                         menuItems={[]}
                                         selectedData={areAllSelected ? selectedRows : selectedRows.length}
                                         handleAnnullaClick={handleAnnullaClick}/>

            {/* The component main table for displaying the data */}
            <EsitoCambioFormatoTable selected={selectedRows}
                                setSelected={setSelectedRows}
                                page={page}
                                rowsPerPage={rowsPerPage}
                                handlePaginationChange={handleTablePaginationChange}
                                areAllSelected={areAllSelected}
                                setAreAllSelected={setAreAllSelected}
                                filter={filterHistory}/>
        </>
    )
}

export default EsitoCambioFormato;